
export const validateVAT = (value, countryCode = 'FR') => {
  if (!value) return false;
  const cleanValue = value.toString().trim();
  
  if (cleanValue.length < 8) return false;
  
  switch(countryCode.toUpperCase()) {
    case 'FR':
      return /^FR[0-9A-Z]{2}[0-9]{9}$/.test(cleanValue);
    case 'BE':
      return /^BE[0-9]{10}$/.test(cleanValue);
    default:
      return /^[A-Z]{2}[0-9A-Z]{6,}$/.test(cleanValue);
  }
};
export const validateNIFPT = (value) => {
  if (!value) return false;
  const cleanValue = value.toString().trim();
    const regex = /^[0-9]{9}$/;
  if (!regex.test(cleanValue)) return false;
  
 
  return true;
};


export const validateNIFHU = (value) => {
  if (!value) return false;
  const cleanValue = value.toString().trim();
  
  const regex = /^([0-9]{8}-[0-9]-[0-9]{2})$/;
  return regex.test(cleanValue);
};


export const validateTaxId = (value, taxIdType, { isOptional = false } = {}) => {
  if ((!value || value.trim() === "") && isOptional) {
    return true;
  }
  
  if (value && value.trim() !== '') {
    const normalizedType = taxIdType.replace(" ", "");
    
    if (normalizedType === "NIFPT") {
      return validateNIFPT(value);
    } else if (normalizedType === "NIFHU") {
      return validateNIFHU(value);
    }
  }
  
  return false;
};

export function luhnChecksum(code) {
    const len = code.length;
    const parity = len % 2;
    let sum = 0;
    
    for (let i = len - 1; i >= 0; i--) {
      let d = parseInt(code.charAt(i), 10);
      if (i % 2 === parity) { d *= 2; }
      if (d > 9) { d -= 9; }
      sum += d;
    }
    
    return sum % 10;
  }
  

  export function validateIkeaFamily(value) {
    const clientId = value ? (typeof value === 'string' ? value : value.toString()) : '';
    const regex = /^6275980\d{12}$/;
    
    if (regex.test(clientId)) {
      return luhnChecksum(clientId) === 0;
    }
    
    return false;
  }
  

  export function validateIkeaBusiness(value) {
    const clientId = value ? (typeof value === 'string' ? value : value.toString()) : '';
    const regex = /^6275986\d{12}$/;
    
    if (regex.test(clientId)) {
      return luhnChecksum(clientId) === 0;
    }
    
    return false;
  }
  

  export function validateIkeaFamilyOrBusiness(value) {
    const clientId = value ? (typeof value === 'string' ? value : value.toString()) : '';
    const regex = /^627598[06]\d{12}$/;
    
    if (regex.test(clientId)) {
      return luhnChecksum(clientId) === 0;
    }
    
    return false;
  }
  

  export function validateClientId(value, clientIdType, isOptional = false) {
    if (!clientIdType) return true;
    
    if (isOptional && (!value || value === "")) return true;
    
    const type = clientIdType.replace(/[_ ]/g, '');
    
    const validator = {
      IKEAFAMILY: validateIkeaFamily,
      IKEABUSINESS: validateIkeaBusiness,
      IKEAFAMILYORBUSINESS: validateIkeaFamilyOrBusiness
    }[type];
    
    return validator ? validator(value) : false;
  }